import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import {useDispatch, useSelector} from "react-redux";
import {updateBRBusinessShare} from "../../../actions";
import red from "@material-ui/core/colors/red";
import {Chip, FormControlLabel} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import {Switch} from "@material-ui/core";

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    // margin: theme.spacing(1),
    position: 'relative',
  },
  color1: {
    backgroundColor: green[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  color2: {
    backgroundColor: red[500],
    color: grey[50],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -7,
    left: -7,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -13,
    marginLeft: -12,
  },
});

const ToggleButton = (props) => {

  const {classes, customerId, shareId, shareProperty = "is_active", label = false, title = ""} = props;
  const {customers, customerInView} = useSelector(({customer}) => customer);
  const {portfolios, loadingUpdateBRBusinessShare, loadingUpdateBRBusinessShareError, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
  const [localLoading, setLocalLoading] = useState(false);

  const customerIdToUse = customers ? customerInView ? customerInView : null : null;

  const currentShares =
      portfolios
      && customerIdToUse
      && portfolios[customerIdToUse]
          ? portfolios[customerIdToUse].shares
          : null;

  const sharePropertyState = currentShares && currentShares[shareId] ? currentShares[shareId][shareProperty] : null;

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("printing a user toggle switch for user, ", userId, user);
    //check for this customer and this target's loader.
    const isLoading = loadingUpdateBRBusinessShare
      && shareId
      ? loadingUpdateBRBusinessShare[shareId]
      : null;

    const isError = loadingUpdateBRBusinessShareError
    && shareId
        ? loadingUpdateBRBusinessShareError[shareId]
        : null;

    if (!isLoading || isError) {
      setLocalLoading(false);
    }
  }, [dispatch, loadingUpdateBRBusinessShare]);

  const handleButtonClick = () => {
    // console.log("share toggle button clicked. localoading", localLoading, "shareId", shareId, "sharePropertyState", sharePropertyState);
    if (!localLoading) {
      if (shareId) {
        // switch (shareProperty) {
        //   case "is_active":
            setLocalLoading(true);
            dispatch(updateBRBusinessShare(
                customerId, shareId, shareProperty, !sharePropertyState, null
                // {
                //   "customerId": customerId,
                //   "shareId": shareId,
                //   property: `${shareProperty}`,
                //   newStatus: !sharePropertyState}
            ));
        //     break;
        //
        //   default:
        //     break;
        // }
      }
    }
  };

  // const buttonClassname = classNames({
  //   // [classes.color1]: flipColorLogic? !userPropertyState : userPropertyState,
  //   [classes.color2]: flipColorLogic? sharePropertyState : !sharePropertyState,
  // });

  return (
      <div className={classes.root}>
        <div className={classes.wrapper}>
            {localLoading && <CircularProgress size={26} disableShrink className={classes.buttonProgress}/>}
            {<Tooltip title={title}>
                          <span>
                            <FormControlLabel
                                control = {
                                   <Switch
                                       label={label ? label : sharePropertyState ? "Active" : "Inactive"}
                                       // avatar={names.avatar}
                                       color={sharePropertyState ? "primary" : "default"}
                                       clickable ={!localLoading}
                                       checked={sharePropertyState ? true : false}
                                       onClick={() => handleButtonClick()}
                                       size="medium"
                                       // className={params.row.statusId === 1 || params.row.wasRowJustAdded ? "btn-floating pulse pulse-single" : ""}
                                       // onClick={!isTimelineButtonDisabled ? () => onClickToAttackTimeline(params.row.id) : null}
                                   /> }
                                // label={label ? label : sharePropertyState ? "Active" : "Inactive"}
                                labelPlacement={"bottom"}
                                // style={{ color: "red"}}
                            />

                          </span>
            </Tooltip>}
          {/*</IconButton>*/}

            {/*</Badge>*/}
            </div>

          </div>
  );

}

ToggleButton.propTypes = {
  classes: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired,
  shareId: PropTypes.string.isRequired,
  shareProperty: PropTypes.string,
  // propertyDisplayName: PropTypes.string.isRequired,
  flipColorLogic: PropTypes.bool,
};

export default withStyles(styles)(ToggleButton);